export default  {
  // PRICING related data
  // =============================================

  prices: [],
  priceCategories: {},
  priceTypes: {},
  priceTypeRules: [],
  currency: '',
  areaNames: {
    levels:   {},
    sections: {}
  },
  config: {
    ticketLimit:       0,
    memberTicketLimit: 0,
    avoidSingleSeats: false
  },
  eventIneligibilityCause: null,

  // BASKET related data
  // =============================================

  // basket show/hide tickets
  showTickets: false,
  // show loader when buying
  isBuying: false,
  // this is calculated on the "done" function
  total: 0,
  count: 0,
  urls: { ism: '', suggestions: '' },
  reCaptcha: {
    showRecaptcha: false
  },
  showServiceFeeBreakdown: false,
  // holds all the error that can happen during ticket purchasing process
  error: {
    errorCode: null,
    payload: null,
    translations: null
  },
  unocFee: {
    showUnocFee: false,
    unocFeeTotal: 0
  },

  // SEATMAP related data
  // =============================================

  // in GA and PriceType Overalys
  isUnlockingPriceType: false,
  priceTypeJustUnlocked: false,
  // Has there been an attempt to add a seat blocked?
  attemptedToSelectSeat: false,
  attemptedToBuyTicket: false,
  hasSingleSeat: false,

  // keeps track of seats/GA seats
  // seated
  unassignedSeat: null,
  activeSeats: {},

  // GA
  GASeats: {},
  sectionBasket: {},
  quantityInSections: {}
};



// WEBPACK FOOTER //
// ./frontend/react/stores/basket/basket_schema.js